export default __webpack_public_path__ + "static/media/best.cbb795c6.png";